import script from "./Case5.vue?vue&type=script&setup=true&lang=js"
export * from "./Case5.vue?vue&type=script&setup=true&lang=js"

import "./Case5.vue?vue&type=style&index=0&id=0560fe1c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0560fe1c"]])

export default __exports__